export default __webpack_public_path__ + "static/choreography-light-fbcb093aee6e875ae3c1f380901d2e2e.mp4";